require('../../scss/app-destinations.scss');

import Application from "./application";
import MobileMenuBehavior from "../behaviours/mobile-menu-behaviour";
import ShortlistCount from "../jsx/shortlist/shortlist-count";
import ShortlistButton from "../jsx/shortlist/shortlist-button";
import ToggleClassBehavior from "../behaviours/toggle-class-behaviour";



let config = {};

//Create Class to extend default behavior and tell it what react components to load.
config.behaviours = {
  "MobileMenuBehaviour": new MobileMenuBehavior(),
  'ToggleClassBehaviour': new ToggleClassBehavior(),

};

config.components = {
  "shortlist-count": ShortlistCount,
  "shortlist-button": ShortlistButton,
};

new Application(config);

[...document.querySelectorAll('.az-list--nav-item')].map(navItem => {
  navItem.addEventListener('click', e => {
    [...document.querySelectorAll('.az-list--category')].map(cat => cat.classList.remove('az-list--category-show'));
    [...document.querySelectorAll('.az-list--nav-item')].map(cat => cat.classList.remove('az-list--nav-item-active'));

    const target = e.target.getAttribute('data-target');

    if (target) {
      e.target.classList.add('az-list--nav-item-active');
      document.querySelector(target).classList.add('az-list--category-show');
    } else {
      [...document.querySelectorAll('.az-list--category')].map(cat => cat.classList.add('az-list--category-show'));
    }

  })
});



document.readyState !== "loading" ? window.initApp() : document.addEventListener("DOMContentLoaded",  window.initApp);